/* @flow */

import * as React from 'react';

import { connect } from 'react-redux';

import { selectCartUUID as selectCartId } from '@gandi/cart';
import { useTranslator, type TranslatorProps } from '@gandi/translate';

import { Cell } from '@gandi/ui';
import { ListRow, ListItem, Action } from '@gandi/ui/deprecated';

import type { FullState } from '../../../types';

import { stringify } from './helpers';

import type { CartCouponSuggestion } from './types';

export type OwnProps = {
  coupon: CartCouponSuggestion,
};

export type StateProps = {
  cartId: string,
};

export type Props = {
  ...OwnProps,
  ...StateProps,
};

function getTranslations(
  reason: CartCouponSuggestion['reason'],
  __: TranslatorProps['__'],
) {
  let label;
  let description;

  // eslint-disable-next-line default-case
  switch (reason) {
    case 'at_least_one_domain_and_first_shs':
    case 'at_least_one_domain_and_no_shs':
      label = __(
        'Get 50%% off your Simple Hosting order! ' +
          'This promotional offer will be automatically applied to this order, ' +
          'for any pack you choose and any duration',
      );
      description = __('Try Simple Hosting');
  }

  return label && description ? { label, description } : undefined;
}

function Coupon(props: Props): null | React.Node {
  const {
    cartId,
    coupon: { reason, discount },
  } = props;
  const { __ } = useTranslator();

  const translations = getTranslations(reason, __);
  if (!translations) {
    return null;
  }

  const params = { cross_sell: 1, discountCode: discount.code, reason };
  const queryString = stringify(params);

  const to = `/simplehosting/create/${String(cartId)}${queryString}`;

  return (
    <ListRow separatorBottom>
      <ListItem>
        <Cell flexGrow1>{translations.label}</Cell>
        <Cell>{translations.description}</Cell>
      </ListItem>
      <Action to={to} icon="plus">
        {__('Add to cart')}
      </Action>
    </ListRow>
  );
}

const mapStateToProps = (state: FullState): StateProps => ({
  cartId: selectCartId(state),
});

// $FlowFixMe[signature-verification-failure]
// $FlowFixMe[underconstrained-implicit-instantiation]
export default connect(mapStateToProps)(Coupon);
